var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading-placeholder"},[_c('loading-symbol')],1):_c('div',[_c('benefit-categories-view',{attrs:{"categories":_vm.rootCategories}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }